export default __webpack_public_path__ + "static/media/YES_Clothing_Contrast_M.917e99e1.jpg";